import { Dispatch, SetStateAction, useRef, useState } from 'react';

import { useGenerateFile, useJobChecker } from 'cliOld/hooks';
import { FileType } from 'coreOld/enums';
import { useCloseMenuIfClickedOutside, useFilesActions } from 'coreOld/hooks';
import { ImportType } from 'corporate/enums';
import { ModalStep } from 'partsOld/enums';
import { useImportPartsActions } from 'partsOld/hooks';

import UploadFileView from './UploadFileView';

interface IProps {
  onSubmit: (value) => void;
  setStep: Dispatch<SetStateAction<ModalStep>>;
  setImportType: Dispatch<SetStateAction<ImportType>>;
}

const UploadFile = ({ onSubmit, setStep, setImportType }: IProps) => {
  const ref = useRef(null);

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const { fileUpload } = useFilesActions();
  const { importUomConversions } = useImportPartsActions();
  const { checkJobStatus } = useJobChecker();
  const { onGenerateFileFinished, onGenerateFileStopped } = useGenerateFile();

  useCloseMenuIfClickedOutside(ref, isMenuOpen, () => setIsMenuOpen(false));

  const onItemClick = () => {
    setIsMenuOpen(false);
  };

  const onUomConversions = async (fileId: number) => {
    if (!fileId) {
      return;
    }

    const data = await importUomConversions({ file: fileId });

    checkJobStatus(
      data,
      (cliJob) => onGenerateFileFinished(cliJob),
      (cliJob) => onGenerateFileStopped(cliJob)
    );
  };

  const onChange = async (file, type: ImportType) => {
    if (!file) {
      return;
    }

    const queryParams =
      type === ImportType.UOMS
        ? { fileType: 'uom_conversion_import', allowedTypes: [FileType.CSV] }
        : { fileType: 'corporate_part_import' };

    const { data } = await fileUpload(file, queryParams);

    setImportType(type);

    if (type === ImportType.UOMS) {
      await onUomConversions(data[0]?.id);

      return;
    }

    onSubmit({ fileId: data[0]?.id });
    setStep(
      type === ImportType.PART_ATTRIBUTES ? ModalStep.COLUMNS_HEADERS : ModalStep.COST_MANUFACTURER
    );
  };

  return (
    <UploadFileView
      {...{
        isMenuOpen,
        setIsMenuOpen,
        onItemClick,
        onChange,
        ref,
      }}
    />
  );
};

export default UploadFile;
